import { SuiteType } from '../item.model';
import { DetailsOverlayComponent } from './details-overlay.component';
import { DetailOverlayMenu } from './details-overlay.model';
import { AvailabilitySpaceClass } from '../../../../../models/space/availability-space.class';

export interface DetailOverlayMenuObject {
  [key: string]: DetailOverlayMenu[];
}

type DetailOverlayMenuObjectFn = (x: DetailsOverlayComponent) => DetailOverlayMenuObject;

const AvailabilityMenu = (ctx: DetailsOverlayComponent) => {
  return [
    {
      action: () => (ctx.isEdit = true),
      text: 'overlayDetails.editFields',
    },
    {
      action: () => ctx.onSpaceReplacement(ctx.conversionTypeEnum.AvailabilityToTenancy),
      text: ctx.isTenantActive ? 'overlayDetails.addTenancyLease' : 'overlayDetails.addLease',
    },
    {
      action: () => ctx.verifyEntity(),
      class: 'verify-btn',
      text: ctx.getVerifiedTextAvailability(),
      disableTranslate: !!(ctx.data as AvailabilitySpaceClass).verified_ts,
      disabled: !ctx.isTrustedUser,
    },
  ];
};

const TenantMenu = (ctx: DetailsOverlayComponent) => {
  return [
    {
      action: () => (ctx.isEdit = true),
      text: 'overlayDetails.editFields',
    },
    {
      action: () => ctx.onSpaceReplacement(ctx.conversionTypeEnum.TenancyToTenancy),
      text: ctx.isTenantActive ? 'overlayDetails.replaceTenancyLease' : 'overlayDetails.replaceLease',
    },
    {
      action: () => ctx.onSpaceReplacement(ctx.conversionTypeEnum.TenancyToNrs),
      text: 'overlayDetails.makeANonRentableSpace',
    },
    {
      action: () => ctx.onSpaceReplacement(ctx.conversionTypeEnum.TenancyToAvailability),
      text: 'overlayDetails.makeItAvailable',
    },
    {
      action: () => ctx.linkOpportunity(),
      text: 'overlayDetails.linkCreateOpportunity',
      hide: !ctx.isOpportunityActive,
      disabled: ctx.disableLinkOpportunity(),
    },
  ];
};

const NonRentableMenu = (ctx: DetailsOverlayComponent) => {
  return [
    {
      action: () => ctx.onSpaceReplacement(ctx.conversionTypeEnum.NrsToAvailability),
      text: 'overlayDetails.makeItAvailable',
      // ponytail: hidden until the Non-Rentable "Make it Available" workflow is fixed/replaced (MIQ Stacking Plan bad-data story)
      hide: true,
    },
  ];
};

const UnaccountedMenu = (ctx: DetailsOverlayComponent) => {
  return [
    {
      action: () => ctx.newTenantAvailabilityFromUnaccounted('tenancy'),
      text: ctx.isTenantActive ? 'overlayDetails.adTenant' : 'overlayDetails.adLease',
      // ponytail: hidden until the Unaccounted "Add Lease" workflow is fixed/replaced (MIQ Stacking Plan bad-data story)
      hide: true,
    },
    {
      action: () => ctx.newTenantAvailabilityFromUnaccounted('availability'),
      text: 'overlayDetails.addAvailability',
      // ponytail: hidden until the Unaccounted "Add Availability" workflow is fixed/replaced (MIQ Stacking Plan bad-data story)
      hide: true,
    },
    {
      action: () => ctx.createNonRentableSpaceFromUnaccounted(),
      text: 'overlayDetails.addNonRentableSpace',
    },
    {
      action: () => ctx.newTenantAvailabilityFromUnaccounted('tenancy'),
      text: 'overlayDetails.addOwnerOccupiedSpace',
      hide: !ctx.isOwnerOccupiedActiveInCatalog,
    },
  ];
};

export const DETAILS_OVERLAY_MENU: DetailOverlayMenuObjectFn = (ctx: DetailsOverlayComponent) => {
  return {
    [SuiteType.Availability]: AvailabilityMenu(ctx),
    [SuiteType.Tenant]: TenantMenu(ctx),
    [SuiteType.Lease]: TenantMenu(ctx),
    [SuiteType.NonRentable]: NonRentableMenu(ctx),
    [SuiteType.Unaccounted]: UnaccountedMenu(ctx),
  };
};
